import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { Page, Header } from 'components';
import Vmo2Report from './components/Vmo2Report';
import DownloadsVmo2 from './components/DownloadsVmo2';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const ReportsKpisVmo2 = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Reports Kpis VMO2">
			<Header module="Modules" view="Reports Kpis VMO2" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<Vmo2Report />
					<DownloadsVmo2 />
				</Grid>
			</Grid>
		</Page>
	);
};

export default ReportsKpisVmo2;
